module.exports = __webpack_public_path__ + "static/img/profile_left_bottom.1e2a7997.png";